// extracted by mini-css-extract-plugin
module.exports = {"chips":"chips-2SaqO","left":"left-g78Dv","right":"right-xHY1L","center":"center-r2lxe"};